import ProgramAssistant from './ProgramAssistant';

export default ProgramAssistant;
